"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = function _default() {
  let prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return [_react.default.createElement("path", {
    d: "M17.332 2.2095c.2906-.2793.7618-.2793 1.0524 0 .2906.2793.2906.732 0 1.0114L15.0463 6.429l.5955.5723 4.1109-3.951c.2906-.2793.7617-.2793 1.0523 0 .2906.2793.2906.7321 0 1.0114l-4.1109 3.951.5955.5723 3.338-3.2082c.2906-.2793.7618-.2793 1.0524 0 .2906.2793.2906.732 0 1.0114l-3.3381 3.2082.5955.5723 1.7924-1.7226c.2906-.2793.7617-.2793 1.0523 0 .2906.2792.2906.732 0 1.0114-1.5434 1.4812-3.0663 3.518-4.9773 4.5422-.1184-.964-.9401-1.7104-1.9361-1.7104h-4.2942c-.3788-.6563-.58-1.4011-.5743-2.1652l.0413-5.5408c.0034-.4488.3259-.8376.78-.942.5755-.1322 1.1477.2345 1.24.7962l.4025 2.4503 4.868-4.6784z"
  }), _react.default.createElement("path", {
    d: "M15.2669 15.9379a.7332.7332 0 1 1 0 1.4664H9.5385v.8297h4.6514a.7332.7332 0 1 1 0 1.4664H9.5385v.8298h2.4976a.7332.7332 0 0 1 0 1.4664l-5.5262-.0039C4.019 21.9927 2 19.9735 2 17.4828a4.51 4.51 0 0 1 1.3439-3.2118l4.0456-3.9879a1.0011 1.0011 0 0 1 1.2262-.1394c.4969.305.6297.9696.2868 1.4411l-1.4959 2.0568 6.7833.0001a.7332.7332 0 1 1 0 1.4664H9.5385v.8298h5.7284z"
  })];
};

exports.default = _default;